function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.989 5L16.297 7.461C16.16 7.425 1 6.775 1 6.775c-.01.57.381 1.055.91 1.174L15.096 10.7c.096.36.296.696.599.954l.916.78v.667l-1.24 1.974.013.019a1.332 1.332 0 00-.303 1.165 1.497 1.497 0 00-.758-.59 1.581 1.581 0 00-2.019 1 1.62 1.62 0 00.919 2.027l.066.023 1.456.51a.714.714 0 00.911-.452l.091-.267.828 2.751-.623 5.728c.414.052.719-.115.937-.7l1.07-4.121a.797.797 0 00.027-.13l.09-.752.001-.007c.003-.028.002-.056.002-.085 0-.02.003-.041.001-.062l-.25-3.054-.252-1.96.154-.043.493 1.098c.8-.535 1.39-1.4 1.478-2.38l.117-2.556-.283-1.733-1.106-.064-.036-.135 1.646-.545 10.185-3.483c.51-.183.84-.712.762-1.278z",
  fill: "currentColor"
})));